import { render, staticRenderFns } from "./OnboardingMembership.vue?vue&type=template&id=6967416c&"
import script from "./OnboardingMembership.vue?vue&type=script&lang=js&"
export * from "./OnboardingMembership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports